<section id="main">
    <div class="mtn-title">
        <p style="text-transform: capitalize;">{{ this.moduleName }}</p>
    </div>
    <div class="form-btns">
        <a (click)="onButtonClick()" class="btn btn2">Click Here to Redirect</a>
    </div>
</section>
